import React from "react";
import LocaleLink from '../../Routes/LocaleLink'
import clsx from 'clsx'

export default function BusinessUnitButton(props) {
    const option = props.option
    const state = props.state
    const pathPrefix = props.prefix ?? '/jobs/'

    const value = (option.value) ? option.value : null

    return (
        <LocaleLink
            to={`${pathPrefix}${option.value}`}
            className={clsx('business_units', { 'active': value ===  state.business_unit })}>
            {option.label}
        </LocaleLink>
    )
}
